{
  "title": "Thought Shield (UA)",
  "source": "Unearthed Arcana 66 - Fighter, Rogue, and Wizard",
  "levelAndSchool": "2nd-level abjuration",
  "level": 2,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S",
  "duration": "8 hours",
  "description": [
    "You weave a clouding veil over the mind of one creature you touch. For the duration, the target’s mind can’t be read or detected, creatures can’t telepathically communicate with the target unless the target allows it, and the target has advantage on saving throws against any effect that would determine whether it is telling the truth."
  ],
  "spellLists": ["eldritch-knight", "sorcerer", "warlock", "wizard"]
}
